/**
 * Where the service worker registers (docs/offline.md): production builds only, on pdfmarkuptool.com (+ www) and on
 * localhost (the e2e preview). Never in dev, Storybook or vitest (they never load main.tsx; `prod` is false there
 * anyway), never on Firebase preview channels (*.web.app) or another host serving a copy.
 */
const SW_HOSTS = /^(?:(?:www\.)?pdfmarkuptool\.com|localhost|127\.0\.0\.1)$/;

export interface RegisterGateEnv {
    prod: boolean;
    hostname: string;
    hasServiceWorker: boolean;
}

export function shouldRegisterServiceWorker({ prod, hostname, hasServiceWorker }: RegisterGateEnv): boolean {
    return prod && hasServiceWorker && SW_HOSTS.test(hostname);
}

/** After the page has loaded (never competing with first paint), load and start the registration chunk. */
export function startServiceWorkerWhenLoaded(start: () => Promise<unknown>, win: Window = window): void {
    const run = () => { void start().catch(() => { /* no worker = the online app as before */ }); };
    if (win.document.readyState === 'complete') run();
    else win.addEventListener('load', run, { once: true });
}
